// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wtw-preview .content[data-v-611364b8]{container:wtw/inline-size;display:flex;gap:16px}@container wtw (width < 768px){.wtw-preview .content[data-v-611364b8]>:not(:first-child){display:none}}", ""]);
// Exports
module.exports = exports;
